import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkGetAllergy } from '../types';

const onGetAllergy: IThunkGetAllergy = thunk(
  async ({ setCurrent }: Actions<IClientDetailsActions>, payload) => {
    const current = await api.clientDetails.getClientAllergy(payload).then(r => r.data);

    setCurrent(current);
  },
);

export default onGetAllergy;
